import { FacetRenderer, isRenderableType, Renderable, RenderableUpdateTriggerState } from "../renderable/Renderable";
import { MeshRenderable } from "../mesh/MeshRenderable";
export class MovingTextureRenderable extends FacetRenderer {
    constructor(owner) {
        super(owner);
        this.owner = owner;
        this.textures = new Map();
        this.update = () => {
            if (this.facet === undefined)
                return;
            for (const param of this.facet.params) {
                const texture = this.textures.get(param.materialName);
                if (texture === undefined)
                    continue;
                texture.offset.x += param.linearVelocity[0];
                texture.offset.y += param.linearVelocity[1];
                texture.rotation += param.angularVelocity;
            }
        };
    }
    destroy() { }
    setVisible(_visible) { }
    updateFacet(facet) {
        this.facet = facet;
        this.applyToRenderable();
    }
    updateTransform() { }
    onOtherRenderableChanged(state, renderable) {
        switch (state) {
            case RenderableUpdateTriggerState.Changed:
                if (renderable instanceof Renderable) {
                    this.applyToRenderable();
                }
                break;
            case RenderableUpdateTriggerState.Destroyed:
                break;
        }
    }
    applyToRenderable() {
        const renderable = this.owner.renderable;
        if (!renderable) {
            return;
        }
        if (isRenderableType(MeshRenderable, renderable)) {
            this.applyToMesh(renderable);
        }
    }
    applyToMesh(mesh) {
        if (this.facet === undefined)
            return;
        if (!mesh.meshInstance.isLoaded)
            return;
        for (const param of this.facet.params) {
            const key = param.materialName;
            if (this.textures.has(key))
                continue;
            const mat = mesh.meshInstance.findMaterialByName(param.materialName);
            // FIXME what the heck? map is not defined for Material!
            if ((mat === null || mat === void 0 ? void 0 : mat.map) !== undefined) {
                const texture = mat.map;
                this.textures.set(key, texture);
            }
        }
        if (this.textures.size > 0) {
            this.registerAnimationCallback(this.update);
        }
        else {
            console.warn("MovingTextureRenderable: no texture was found!");
        }
    }
}
